import { Box } from "@material-ui/core";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { FC } from "react";
import Loader from "router/components/Loader";
import { FleetReportsHead } from "./FleetReportsHead";
import { useStyles } from "./styles";
import FleetReportsStats from "./FleetReportsStats";
import FleetReportsContainers from "./FleetReportsContainers";

interface PropsType {}

const FleetReportsPage: FC<PropsType> = () => {
  const classes = useStyles();
  const { loadingData } = useTypeSelectors((state) => state.fleetReports);

  return (
    <Box className={classes.root} data-testid="testFleetReports">
      <Loader isLoading={loadingData} />
      <FleetReportsHead />
      <Box className={classes.contentBox}>
        <FleetReportsStats />
        <FleetReportsContainers />
      </Box>
    </Box>
  );
};

export default FleetReportsPage;
